<div class="mapa-dialog-container">
    <div class="mapa-header">
        <h2 mat-dialog-title>
            <mat-icon class="header-icon">place</mat-icon>
            Geolocalización del Registro
        </h2>
        <button mat-icon-button (click)="cerrar()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="mapa-content">
        <div class="info-panel" *ngIf="puntos.length > 0">
            <div class="info-item" *ngFor="let punto of puntos; trackBy: trackByIndex">
                <div class="info-text">
                    <div class="info-title">{{ punto.titulo }}</div>
                    <div class="info-desc">{{ punto.descripcion }}</div>
                </div>
            </div>
        </div>

        <div class="mapa-container">
            <div #mapContainer class="mapa-element"></div>

            <div class="mapa-loading" *ngIf="!googleMapsLoaded">
                <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
                <p>Cargando mapa...</p>
            </div>
        </div>
    </div>

    <div class="mapa-actions">
        <button mat-raised-button color="primary" (click)="cerrar()">
            Cerrar
        </button>
    </div>
</div>